import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    ModalFooter,
    Button,
    Text,
    Box,
    Flex,
    useBreakpointValue,
  } from '@chakra-ui/react';
  import { FiAlertTriangle } from 'react-icons/fi';
  
  interface ModalConfirmacaoProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isLoading?: boolean;
    quantidade?: number;
  }
  
  export default function ModalConfirmacao({
    isOpen,
    onClose,
    onConfirm,
    isLoading = false,
    quantidade = 1,
  }: ModalConfirmacaoProps) {
    const alertLeft = useBreakpointValue({ base: '50%', md: '42%' });
  
    return (
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
  
        <Box
          position="absolute"
          top="58px"
          left={alertLeft}
          transform="translate(-50%, -50%)"
          zIndex="2001"
        >
          <Flex
            alignItems="center"
            bg="#117baa"
            borderRadius="30px"
            pl="0"
            pr="20px"
            height="30px"
            boxShadow="md"
          >
            <Box
              as={FiAlertTriangle}
              bg="red.500"
              color="white"
              p="2"
              borderRadius="full"
              w="40px"
              h="40px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize="20px"
              mr="2"
            />
            <Text fontWeight="bold" color="white" fontSize="sm">
              AVISO
            </Text>
          </Flex>
        </Box>
  
        <ModalContent borderRadius="3xl" overflow="hidden" mt="60px">
          <ModalBody bg="gray.50" pt={6}>
            {quantidade === 1 ? (
              <Text textAlign="center" fontSize="md" color="gray.700">
                Tem certeza que deseja <strong>excluir este item</strong> permanentemente?
              </Text>
            ) : (
              <Text textAlign="center" fontSize="md" color="gray.700">
                Você está prestes a deletar <strong>{quantidade} itens selecionados</strong>.
              </Text>
            )}
          </ModalBody>
  
          <ModalFooter bg="gray.50" justifyContent="center" gap={3}>
            <Button
              variant="outline"
              onClick={onClose}
              borderColor="gray.300"
              _hover={{ bg: 'gray.100' }}
            >
              Cancelar
            </Button>
            <Button colorScheme="red" isLoading={isLoading} onClick={onConfirm}>
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
  